<template>
  <div class="sino-transfer">
    <div class="transfer background left">
      <p
        class="transfer-title"
        v-if="$slots.leftTitle"
      >
        <slot name="leftTitle"></slot>
      </p>
      <div
        class="content"
        :class="!$slots.leftTitle?'no-title':''"
      >
        <el-scrollbar
          class="ly-c-scroll"
          v-if="!noScroll"
        >
          <slot name="left">
            <data-empty></data-empty>
          </slot>
        </el-scrollbar>
        <slot
          name="left"
          v-if="noScroll"
        >
          <data-empty></data-empty>
        </slot>
      </div>
    </div>
    <div class="operation">
      <el-button
        icon="el-icon-arrow-right"
        circle
        type="primary"
        :disabled="rightDisabled"
        @click="detach"
      ></el-button>
      <el-button
        :disabled="leftDisabled"
        icon="el-icon-arrow-left"
        circle
        @click="shuttle"
      ></el-button>
    </div>
    <div class="transfer background right">
      <p
        class="transfer-title"
        v-if="$slots.rightTitle"
      >
        <slot name="rightTitle"></slot>
      </p>
      <div
        class="content"
        :class="!$slots.rightTitle?'no-title':''"
      >
        <el-scrollbar
          class="ly-c-scroll"
          v-if="!noScroll"
        >
          <slot name="right">
            <data-empty></data-empty>
          </slot>
        </el-scrollbar>
        <slot
          name="right"
          v-if="noScroll"
        >
          <data-empty></data-empty>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
import dataEmpty from "../../components/dataEmpty.vue";
export default {
  name: "sino-transfer",
  components: {
    dataEmpty,
  },
  props: {
    noScroll: {
      //是否区域内滚动
      type: Boolean,
      default: false,
    },
    rightDisabled: {
      //向右穿梭是否禁用
      type: Boolean,
      default: false,
    },
    leftDisabled: {
      //向右穿梭是否禁用
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },

  methods: {
    /**向右穿梭 */
    detach() {
      this.$emit("detach");
    },
    /**向左穿梭 */
    shuttle() {
      this.$emit("shuttle");
    },
  },
};
</script>
<style lang="scss" scoped>
$primary_hover_color:var(--primary-hover-color, #D4E2F0);
.sino-transfer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .operation {
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /deep/.el-button {
      display: block;
      margin-left: 0;
      padding: 14px;
      i {
        &:before {
          font-weight: 600 !important;
        }
      }
      &.is-disabled {
        color: #96a2ad;
        background-color: $primary_hover_color;
        border-color: $primary_hover_color;
      }
      &:not(:last-child) {
        margin-bottom: 40px;
      }
    }
  }
  /deep/.ly-c-table {
    background: transparent !important;
    thead {
      th,
      tr {
        background: transparent !important;
      }
    }
    th {
      font-weight: normal;
      padding: 12px 0 6px 0 !important;
      border: 0 !important;
    }
    .el-table {
      .el-table__body {
        border-spacing: 0 4px !important;
      }
      .el-table__empty-block{
        background: transparent !important;
      }
      td {
        background: transparent;
        &.el-table__cell {
          border-bottom: 0;
        }
        &:first-child {
          border-radius: 6px 0 0 6px;
        }
        &:last-child {
          border-radius: 0 6px 6px 0;
        }
      }
    }
    .ly-c-custom-page {
      background: transparent;
    }
  }
  &.tree {
    .transfer {
      width: 380px;
      height: 100%;
    }
  }

  .transfer {
    border-radius: 6px;
    padding: 0 12px 12px 12px;
    flex: 1;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    &.background {
      background: #f0f2f5;
    }

    .transfer-title {
      padding: 14px 0;
      font-weight: 500;
      color: #40465f;

      .el-checkbox__label {
        font-weight: 500;
        color: #40465f !important;
      }
    }

    .content {
      // background: #fff;
      flex: 1;
      overflow: hidden;
      // height: calc(100% - 68px);
      border-radius: 6px;
      // padding: 12px;

      &.no-title {
        padding: 20px 0 0 0;
      }

      .el-scrollbar {
        height: 100%;
      }

      .el-tree {
        background: transparent !important;
        width: calc(100% - 17px);

        .el-tree-node__expand-icon {
          &:not(.is-leaf) {
            color: $primaryTextColor;
            opacity: 0.3;
          }
        }

        .el-tree-node__content {
          border-radius: 4px;
          height: 30px;

          &:hover {
            background-color: #f5f7fa;

            .el-button {
              display: inline-block;
            }
          }
        }

        .custom-tree-node {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;

          span {
            display: inline-block;
          }

          .label {
            flex: 1;
            color: #363840;
            font-size: 14px;
          }

          .el-button {
            padding: 0;
            display: none;
          }
        }
      }
    }
  }
}
</style>